import { combineReducers } from 'redux';
import { reloadNotification } from './ReloadNotification';
import { rosterCopyPast as reducerRosterCopyPast } from './reducerRosterCopyPast';

export const rosterCopyPast = combineReducers({
  rosterCopyPast: reducerRosterCopyPast,
  reloadNotification
});
